import { useEffect, useRef } from "react";

// eslint-disable-next-line
export const usePreviousProp = <T>(prop: T) => {
    const prevProp = useRef<T>();

    useEffect(() => {
        prevProp.current = prop;
    });

    return prevProp.current;
};
